const neighborhoodsAllHomepage = {
  displayField: 'titleAdmin',
  name: 'Neighborhoods (All/Multiple) Homepage',
  description: 'For feed of all neighborhoods for a shop/shopGroup',
  fields: [
    {
      id: 'titleAdmin',
      name: 'Title (Admin)',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'title',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug of Shop',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'category' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'heroImg',
      name: 'Hero Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'storyContent',
      name: 'Story Content',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'introTextBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'seo',
      name: 'SEO',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'contentBlocks',
      name: 'Dynamic Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'wideTextImage',
              'CareersWideTextAndImage',
              'StackedTextImageForm',
              'WideStackedTextImageBlock',
              'newsletterForm',
              'contactForm'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: {
    id: 'neighborhoodsAllHomepage',
    version: 16,
    updatedAt: '2023-08-10T16:22:15.740Z'
  }
};
export default neighborhoodsAllHomepage;